import React, { useContext, useEffect, useState } from "react";
import { FiInfo, FiAlertTriangle } from "react-icons/fi";
import { IoIosCloseCircleOutline } from "react-icons/io";
import TradathonContext from "../../context/tradathon/TradathonContext";
import AuthContext from "../../context/auth/authContext";
import ParameterContext from "../../context/parameter/parameterContext";
import { withRouter } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const UserAlert = ({ history }) => {
  const { toggleUserAlertModal } = useContext(ParameterContext);
  const { activeRoom, payForTradathon } = useContext(TradathonContext);
  const { userData, getAmountInWallet, walletData, handlePaymentError } =
    useContext(AuthContext);
  const [paymentLoading, setPaymentLoading] = useState(false);
  // const { walletData } = userData;
  const { room } = activeRoom;
  useEffect(() => {
    getAmountInWallet();
  }, []);
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    setPaymentLoading(true);
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const result = await axios.post(
      "https://api.coinstorey.com/payment/createPaymentOrder",
      {
        pid: userData.profile_data._id,
        walletId: walletData._id,
        amount: Number(
          (
            (activeRoom.room.entryFees - walletData.totalAmt / 100) *
            100
          ).toFixed(2)
        ),
        currency: "INR",
      }
    );
    setPaymentLoading(false);
    if (!result) {
      alert("Server error. Are you online?");
      return;
    }

    const { amount, id, currency } = result.data.data.razorPayResponse;
    const orderId = result.data.data.orderSaved._id;
    const options = {
      key: "rzp_test_FPz88LaFbqnhiX", // Enter the Key ID generated from the Dashboard
      amount: amount.toString(),
      currency: currency,
      name: "CoinStorey",
      description: "Lock your portfolio✔",
      // image: { logo },
      order_id: id,
      handler: async function (response) {
        const data = {
          orderId,
          orderCreationId: id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
        };
        try {
          const result = await axios.post(
            "https://api.coinstorey.com/payment/verifyPayment",
            data
          );
          if (result.data?.success) {
            Swal.fire({
              icon: "success",
              title: "Payment Successful",
              customClass: {
                container: "swal__container",
                closeButton: "swal__button",
                // icon: '...',
                // image: '...',
                // content: '...',
                // htmlContainer: '...',
                // input: '...',
                // inputLabel: '...',
                // validationMessage: '...',
                // actions: '...',
                // confirmButton: '...',
                // denyButton: '...',
                // cancelButton: '...',
                // loader: '...',
                // footer: '....',
                // popup: '...',
                // header: '...',
                // title: '...',
              },
            });
            toggleUserAlertModal();
            getAmountInWallet();
            payForTradathon();
          }
        } catch (err) {
          handlePaymentError({
            orderId,
            orderCreationId: id,
            razorpayPaymentId: response.razorpay_payment_id,
            error: {
              code: "BAD_REQUEST_ERROR",
              description: "Authentication failed due to incorrect otp",
              field: null,
              source: "customer",
              step: "payment_authentication",
              reason: "invalid_otp",
              metadata: {
                payment_id: response.razorpay_payment_id,
                order_id: response.razorpay_order_id,
              },
            },
          });
        }
      },
      prefill: {
        name: userData.profile_data.name,
        email: userData.profile_data.email,
        contact: "9999999999",
      },
      notes: {
        address: "Kolkata",
      },
      theme: {
        color: "#61dafb",
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }
  return (
    walletData &&
    (walletData.totalAmt / 100 < room.entryFees ? (
      <div className="Register">
        <div className="Login__container">
          <div style={{ textAlign: "right" }}>
            <IoIosCloseCircleOutline
              size={40}
              style={{ cursor: "pointer" }}
              onClick={toggleUserAlertModal}
            />
          </div>
          <div className="Register__content">
            <div className="SellAlert__icon">
              <FiAlertTriangle size={100} style={{ color: "#fff" }} />
            </div>
            <h2 style={{ marginBottom: "20px" }}>Info</h2>
            <b>Not Enough Amount in Wallet</b>
            <p>{`Current Wallet Balance:${walletData.totalAmt / 100}`}</p>
            <p>{`Amount to be added:${
              room.entryFees - walletData.totalAmt / 100
            }`}</p>
            <p>Would you like to add money to the wallet?</p>
          </div>

          <div className="Register__social" style={{ marginTop: "10px" }}>
            <button
              className="Register__button"
              onClick={toggleUserAlertModal}
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
                background: "#EFF2F5",
                color: "#000",
              }}
            >
              CANCEL
            </button>
            <button
              className="Register__button"
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
              }}
              onClick={() => {
                displayRazorpay();
              }}
              disabled={paymentLoading}
            >
              OK
              {paymentLoading && (
                <div
                  className="loader1"
                  style={{
                    height: "20px",
                    width: "20px",
                    display: "inline-block",
                    border: "3px solid #f3f3f3",
                    borderTop: "3px solid #8d0792",
                    marginLeft: "5px",
                  }}
                ></div>
              )}
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div className="Register">
        <div className="Login__container">
          <div style={{ textAlign: "right" }}>
            <IoIosCloseCircleOutline
              size={40}
              style={{ cursor: "pointer" }}
              onClick={toggleUserAlertModal}
            />
          </div>
          <div className="Register__content">
            <div className="SellAlert__icon">
              <FiInfo size={100} style={{ color: "#fff" }} />
            </div>
            <h2 style={{ marginBottom: "20px" }}>Info</h2>
            <p>{`Current Wallet Balance:${walletData.totalAmt / 100}`}</p>
            <b>Money will be deducted from your wallet</b>
            <p>Would you like to continue to proceed?</p>
          </div>

          <div className="Register__social" style={{ marginTop: "10px" }}>
            <button
              className="Register__button"
              onClick={toggleUserAlertModal}
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
                background: "#EFF2F5",
                color: "#000",
              }}
            >
              CANCEL
            </button>
            <button
              className="Register__button"
              onClick={() => {
                payForTradathon();
                toggleUserAlertModal();
                getAmountInWallet();
              }}
              style={{
                marginRight: "10px",
                width: "100px",
                borderRadius: "5px",
              }}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    ))
  );
};

export default withRouter(UserAlert);
